import { Component, OnInit, Inject } from '@angular/core';
import { ExcepcionesComponent } from '../excepciones/excepciones.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'environments/environment';

/**
 * Obtenemos el Mensaje a mostrar
 */
export interface SendData {
	data: any;
}

@Component({
	selector: 'app-relacionados-dialog',
	templateUrl: './relacionados-dialog.component.html',
	styleUrls: ['./relacionados-dialog.component.sass']
})

export class RelacionadosDialogComponent implements OnInit {
	retornarValores = [{ confirm: 1, allRelacionados: [] }];
	allData: any;
	facturas: any;
	title: string;
	columns = [{
		caption: 'Tipo comprobante',
		dataField: 'nombre',
		fixed: true,
		allowEditing: false
	},
	{
		caption: 'Serie',
		dataField: 'serie',
		fixed: true,
		allowEditing: false
	},
	{
		caption: 'Folio',
		dataField: 'folio',
		fixed: true,
		allowEditing: false
	},
	{
		caption: 'Importe',
		dataField: 'total',
		fixed: true,
		allowEditing: false
	},
	{
		caption: 'Fecha emisión',
		dataField: 'total',
		fixed: true,
		allowEditing: false
	},
	{
		caption: 'UUID',
		dataField: 'UUID',
		fixed: true,
		allowEditing: false
	}
	];

	objetoGridConfiguration: any = {
		GridOptions: {
			paginacion: 20,
			pageSize: [
				'40',
				'60',
				'80',
				'100'
			]
		},
		ExportExcel: { enabled: false, fileName: 'Historico' },
		ColumnHiding: { hide: true },
		Checkbox: { checkboxmode: 'multiple' },
		Editing: { allowupdate: true, mode: 'cell' },
		Columnchooser: { columnchooser: true },
		SearchPanel: { visible: true, width: 200, placeholder: 'Buscar...', filterRow: true },
		Scroll: { mode: 'infinite' },
		Color: null,
		Detail: { detail: true },
		ToolbarDetail: null,
	};
	allselect: any;
	constructor(
		public dialogRef: MatDialogRef<RelacionadosDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: SendData) {
		this.allData = data;
		this.facturas = this.allData.facturas;
		this.title = this.allData.title;
	};

	ngOnInit() {
	};

	datosMessage = e => {
		try {
			this.allselect = e.data;
		} catch (error) {
			console.log('Error')
		};
	};
	addRelacion() {
		this.retornarValores[0].allRelacionados = this.allselect;
	};
	cancelRelacion() {
		this.retornarValores[0].confirm = 0;
		this.retornarValores[0].allRelacionados = [];
	};

}